import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const settingsAnalytics = new AnalyticsService("Settings");

export const dataMergingAnalytics = new AnalyticsService("Merge Duplicates");

export const notificationSettingsAnalytics = settingsAnalytics.extend(["Notifications"]);

export default settingsAnalytics;
